import { ShieldCheck } from "lucide-react";

const links = [
  { label: "O problema", href: "#" },
  { label: "Capítulos", href: "#capitulos" },
  { label: "Oferta", href: "#oferta" },
];

const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-[rgba(212,175,55,0.18)] px-6 py-14 lg:px-12">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 sm:flex-row sm:justify-between">
      <div>
        <p className="font-serif-display text-xl font-bold text-white">
          Social Media <span className="italic text-[#D4AF37]">na Prática</span>
        </p>
        <p className="font-mono-label mt-2 text-[10px] uppercase tracking-[0.3em] text-[#71717A]">
          Do zero ao primeiro cliente, sem complicação
        </p>
      </div>
      <nav className="flex items-center gap-8">
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]"
          >
            {link.label}
          </a>
        ))}
      </nav>
      <div data-testid="footer-monetizze-badge" className="flex items-center gap-2 text-[#71717A]">
        <ShieldCheck className="h-4 w-4 text-[#D4AF37]" />
        <span className="text-xs">Pagamento seguro via Monetizze</span>
      </div>
    </div>
    <div className="mx-auto mt-10 max-w-7xl border-t border-[rgba(255,255,255,0.06)] pt-8 text-center">
      <p className="text-xs text-[#3f3f46]">© {new Date().getFullYear()} Social Media na Prática. Todos os direitos reservados.</p>
    </div>
  </footer>
);

export default Footer;
